__turbopack_context__.v({
  "cPagination": "style-module-scss-module__TJ3JBq__cPagination",
  "cPagination__buttonsWrap": "style-module-scss-module__TJ3JBq__cPagination__buttonsWrap",
  "cPagination__select": "style-module-scss-module__TJ3JBq__cPagination__select",
});
